import { ReactNode, RefObject } from 'react';

import { Box, Flex, Skeleton, Text } from '@tradener/lumen';

export interface CounterpartyScrollableChartCardProps {
  isLoaded: boolean;
  title: string;
  subtitle?: string;
  chartWidth: string;
  scrollRef: RefObject<HTMLDivElement>;
  chartScrollSx: Record<string, unknown>;
  onScroll: () => void;
  children: ReactNode;
}

function CounterpartyScrollableChartCard({
  isLoaded,
  title,
  subtitle,
  chartWidth,
  scrollRef,
  chartScrollSx,
  onScroll,
  children,
}: CounterpartyScrollableChartCardProps) {
  return (
    <Skeleton isLoaded={isLoaded} borderRadius="xl" height="30rem" flex="1">
      <Flex
        width="full"
        height="full"
        borderRadius="xl"
        borderWidth="1px"
        borderColor="gray.0"
        bg="gray.0"
        overflow="hidden"
        position="relative"
      >
        <Flex
          position="absolute"
          top="5"
          left="5"
          zIndex={2}
          direction="column"
          rowGap="0.5"
          bg="gray.0"
          pr="3"
          pointerEvents="none"
        >
          <Text textStyle="subheading1-semibold">{title}</Text>
          {subtitle ? (
            <Text textStyle="body2-regular" color="gray.500">
              {subtitle}
            </Text>
          ) : null}
        </Flex>

        <Flex ref={scrollRef} overflowX="auto" overflowY="hidden" width="full" sx={chartScrollSx} onScroll={onScroll}>
          <Box width={chartWidth} flexShrink={0}>
            {children}
          </Box>
        </Flex>
      </Flex>
    </Skeleton>
  );
}

export default CounterpartyScrollableChartCard;
